export default __webpack_public_path__ + "static/media/full-stack.f6a26b0a.jpg";